import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as analyticsApi from '../api/analytics';

// Overview hook
export function useOverview(range) {
  return useQuery({
    queryKey: ['analytics', 'overview', range],
    queryFn: () => analyticsApi.fetchOverview(range),
    enabled: !!range,
  });
}

// Listings hook
export function useListings({ range, sort, dir, page, pageSize, search }) {
  return useQuery({
    queryKey: ['analytics', 'listings', range, sort, dir, page, pageSize, search],
    queryFn: () => analyticsApi.fetchListings({ range, sort, dir, page, pageSize, search }),
    enabled: !!range,
    keepPreviousData: true,
  });
}

// Listing Funnel hook
export function useListingFunnel(listingId, range) {
  return useQuery({
    queryKey: ['analytics', 'listing-funnel', listingId, range],
    queryFn: () => analyticsApi.fetchListingFunnel(listingId, range),
    enabled: !!listingId && !!range,
  });
}

// Ads Advanced hook
export function useAdsAdvanced(range) {
  return useQuery({
    queryKey: ['analytics', 'ads-advanced', range],
    queryFn: () => analyticsApi.fetchAdsAdvanced(range),
    enabled: !!range,
  });
}

// Benchmarks hook
export function useBenchmarks({ range, categoryId, tier, metro }) {
  return useQuery({
    queryKey: ['analytics', 'benchmarks', range, categoryId, tier, metro],
    queryFn: () => analyticsApi.fetchBenchmarks({ range, categoryId, tier, metro }),
    enabled: !!range,
  });
}

// Recommendations hook
export function useRecommendations({ range, categoryId, metro }) {
  return useQuery({
    queryKey: ['analytics', 'recommendations', range, categoryId, metro],
    queryFn: () => analyticsApi.fetchRecommendations({ range, categoryId, metro }),
    enabled: !!range,
  });
}

// Nudges hook
export function useNudges(range) {
  return useQuery({
    queryKey: ['analytics', 'nudges', range],
    queryFn: () => analyticsApi.fetchNudges(range),
    enabled: !!range,
  });
}

// Dismiss Nudge mutation
export function useDismissNudge() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: analyticsApi.dismissNudge,
    onSuccess: () => {
      // Invalidate nudges queries to refetch
      queryClient.invalidateQueries(['analytics', 'nudges']);
    },
  });
}
